import { css, styled } from '@styles/theme'

export const stylesSimulatedHistoric = {
	containerHisoricalItems: css({
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		gap: '32px',
		marginTop: '40px',
	}),

	containerInput: css({
		display: 'flex',
		justifyContent: 'flex-end',
	}),

	HistoricItem: styled('div', {
		display: 'flex',
		flexDirection: 'column',
		alignItems: ' flex-start',
		padding: '32px',
		gap: '32px',
		cursor: 'pointer',

		width: '323px',
		height: '100%',
		minHeight: '195px',

		background: '$neutral10',
		border: ' 1px solid $neutral50',
		borderRadius: '12px',
	}),

	contentStatus: css({
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',

		paddingBottom: '20px',
		borderBottom: '1px solid #D9D9D9',
	}),

	contentStatus2: css({
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',

		paddingTop: '20px',
	}),
}
